import { head } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { GET_OFFER_BY_IDENTIFIER, GET_OFFER_BY_IDENTIFIER_WITH_ORGANISATION } from '../use-get-all-offers/queries.gql';
import uniqueContentWithDraftPrecedence from '../../../../cms/utils/unique-content-with-draft-precedence';

type UseGetOfferByIdentifierSlugOptions = {
  id: string;
  withOrganisation?: boolean;
};

const useGetOfferByIdentifierSlug = ({ id, withOrganisation = false }: UseGetOfferByIdentifierSlugOptions) => {
  const query = withOrganisation ? GET_OFFER_BY_IDENTIFIER_WITH_ORGANISATION : GET_OFFER_BY_IDENTIFIER;
  const { data, loading } = useQuery(query, { variables: { identifier: id } });
  const allOffers = uniqueContentWithDraftPrecedence(data?.allOffer);
  return { loading, offer: head(allOffers) || null };
};

export default useGetOfferByIdentifierSlug;
